/* Bacci Brave: one isolated studio per Shopify page, clean editor lifecycle. */
(() => {
  if (customElements.get('bacci-brave-studio')) return;
  class BacciBraveStudio extends HTMLElement {
    connectedCallback() {
      if (this.frame) return;
      const template = this.querySelector('template');
      const settings = this.querySelector('script[type="application/json"]');
      if (!template || !settings) return;
      let config;
      try { config = JSON.parse(settings.textContent); }
      catch (_) { this.showError(); return; }
      for (const [key, value] of Object.entries(config.destinations || {})) {
        if (typeof value !== 'string' || !value) continue;
        try {
          const parsed = new URL(value, location.origin);
          config.destinations[key] = parsed.protocol === 'https:' ? parsed.href : null;
        } catch (_) { config.destinations[key] = null; }
      }
      this.frame = document.createElement('iframe');
      this.frame.title = 'Bacci Kid Brave coloring studio';
      this.frame.setAttribute('allow', 'fullscreen');
      this.frame.setAttribute('allowfullscreen', '');
      this.frame.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-downloads allow-modals allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation');
      this.frame.className = 'bacci-brave-frame';
      this.frame.addEventListener('load', () => {
        const loading = this.querySelector('[data-bacci-loading]');
        if (!loading) return;
        if (this.frame?.contentWindow?.BacciDashboard) loading.hidden = true;
        else loading.textContent='Some studio tools could not load. Please reload the page to try again.';
      }, {once:true});
      const safe = value => JSON.stringify(value).replace(/</g, '\\u003c');
      const setup = '<script>window.BacciAssets=' + safe(config.assets) + ';window.BacciShopifyConfig=' + safe({destinations:config.destinations,editor:config.editor}) + ';<\/script>';
      this.frame.srcdoc = '<!doctype html><html lang="en"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><base target="_top"><title>Bacci Kid Brave</title><style>body{margin:0}*{box-sizing:border-box}</style>' + setup + '</head><body>' + template.innerHTML + '</body></html>';
      this.append(this.frame);
      this.resize = () => {
        const top = Math.max(0, this.getBoundingClientRect().top);
        this.frame.style.height = Math.max(440, window.innerHeight - top - 12) + 'px';
      };
      this.resize();
      window.addEventListener('resize', this.resize, {passive:true});
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.resize);
      this.frame?.remove();
      this.frame = null;
    }
    showError() {
      const loading=this.querySelector('[data-bacci-loading]');
      if (loading) loading.textContent='The studio could not open. Please reload the page.';
    }
  }
  customElements.define('bacci-brave-studio', BacciBraveStudio);
})();
